import { Image, Radio } from "antd"
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Question } from "@types";

interface Props {
  question: Question;
}

export const ImageOption = ({question}: Props) => {
    const [checked, setChecked] = useState<string>(question.playerAnswers?.[0]?.id || "");

   useEffect(() => {
    if (question) {
      setChecked((question?.playerAnswers?.[0]?.id) || "");
    }
  }, [question])

    return (
      <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
       <Radio.Group value={checked} style={{ width: "100%", textAlign: "center" }}  >
       {question?.answers.map((answer, index) => (
          <Radio
            value={answer.id}
            key={index}
            style={{ flexDirection: "column-reverse" }}
          >
            <div
              style={{ width: "200px" }}
              className={answer.isCorrect ? "custom-radio-btn-valid" : checked === answer.id ? "custom-radio-btn-invalid" : "custom-radio-btn"}
            >
              <Image
                preview={false}
                src={`data:image/${answer.answerImageViewModel?.extension};base64,${answer.answerImageViewModel?.base64Value}`}
              />
            </div>
          </Radio>
        ))}
       
      </Radio.Group>
      </motion.div>
       
    )
}